import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown,
  Checkbox
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardPatientQueueUX = (props: any) => {
    return(
      <div
        id="CardPatientQueueUX-div-0"
        style={{ padding: "15px 10px", height: "100%" }}>
        <div
          id="CardPatientQueueUX-div-1">

          <Form
            id="CardPatientQueueUX-Form-2">
            <FormGroup
              id="CardPatientQueueUX-FormGroup-32"
              style={{ display: "flex", alignItems: "center" }}>
              <FormField
                id="CardPatientQueueUX-FormField-34">
                <label
                  id="CardPatientQueueUX-label-43"
                  style={{ minWidth: "max-content" }}>
                  Member ID
                </label>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-35"
                width="3">
                <div
                  id="CardPatientQueueUX-div-47">

                  <Input
                    id="CardPatientQueueUX-Input-52"
                    name="patient__hn"
                    onChange={props.onChangeData}
                    value={props.patientQueueFilter?.patient__hn}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-36"
                style={{ marginLeft: "30px" }}>
                <label
                  id="CardPatientQueueUX-label-44"
                  style={{ minWidth: "max-content" }}>
                  ชื่อ - นามสกุล
                </label>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-37"
                width="2">
                <div
                  id="CardPatientQueueUX-div-48">

                  <Input
                    id="CardPatientQueueUX-Input-53"
                    name="first_name"
                    onChange={props.onChangeData}
                    value={props.patientQueueFilter?.first_name}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-38"
                width="2">
                <div
                  id="CardPatientQueueUX-div-49">

                  <Input
                    id="CardPatientQueueUX-Input-54"
                    name="last_name"
                    onChange={props.onChangeData}
                    value={props.patientQueueFilter?.last_name}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-39"
                style={{ marginLeft: "30px" }}>
                <label
                  id="CardPatientQueueUX-label-45"
                  style={{ minWidth: "max-content" }}>
                  วันที่ตรวจ
                </label>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-40"
                width="2">
                <div
                  id="CardPatientQueueUX-div-50">

                  <DateTextBox
                    id="CardPatientQueueUX-DateTextBox-55"
                    onChange={props.onChangeFromDate}
                    value={props.patientQueueFilter?.from_date}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-41">
                <label
                  id="CardPatientQueueUX-label-46"
                  style={{ minWidth: "max-content" }}>
                  ถึง
                </label>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-42"
                width="2">
                <div
                  id="CardPatientQueueUX-div-51">

                  <DateTextBox
                    id="CardPatientQueueUX-DateTextBox-56"
                    onChange={props.onChangeToDate}
                    value={props.patientQueueFilter?.to_date}>
                  </DateTextBox>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardPatientQueueUX-FormGroup-33"
              style={{ display: "flex", alignItems: "center" }}>
              <FormField
                id="CardPatientQueueUX-FormField-57">
                <label
                  id="CardPatientQueueUX-label-62">
                  สถานะรับบริการ
                </label>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-58"
                width="3">
                <div
                  id="CardPatientQueueUX-div-64">

                  <Dropdown
                    fluid={true}
                    id="CardPatientQueueUX-Dropdown-70"
                    name="status"
                    onChange={props.onChangeData}
                    options={props.encounterStatusOptions}
                    selection={true}
                    value={props.patientQueueFilter?.status}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-59"
                style={{ marginLeft: "30px" }}>
                <div
                  id="CardPatientQueueUX-div-71">

                  <Checkbox
                    checked={props.patientQueueFilter?.exclude_canceled}
                    id="CardPatientQueueUX-Checkbox-79"
                    label="แสดงรายการที่ไม่ถูกยกเลิก"
                    name="exclude_canceled"
                    onChange={props.onChangeData}>
                  </Checkbox>
                </div>
                <div
                  id="CardPatientQueueUX-div-75">

                  <Checkbox
                    checked={props.patientQueueFilter?.exclude_finished}
                    id="CardPatientQueueUX-Checkbox-78"
                    label="แสดงรายการที่ยังไม่รับบริการเสร็จสิ้น"
                    name="exclude_finished"
                    onChange={props.onChangeData}>
                  </Checkbox>
                </div>
              </FormField>
              <FormField
                id="CardPatientQueueUX-FormField-60"
                style={{ marginLeft: "30px" }}>
                <div
                  id="CardPatientQueueUX-div-74"
                  style={{ display: "flex", gap: "10px" }}>

                  <div
                    id="CardPatientQueueUX-div-76">
                    {props.buttonSearch}
                  </div>
                  <div
                    id="CardPatientQueueUX-div-77">
                    {props.buttonPrint}
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <div
            id="CardPatientQueueUX-div-80">

            <Table
              className="--rt-tbody-overflow-y-hidden"
              data={props.patientQueueData}
              defaultPageSize={props.defaultPageSize}
              headers={`MemberID\n(หมายเลขรับบริการ),ชื่อผู้รับบริการ,วันเวลารับบริการ,วันเวลานัดหมาย,คัดกรอง,เอกสารสำหรับผู้รับบริการ,พิมพ์LMR,สถานะรับบริการ,,`}
              id="CardPatientQueueUX-Table-81"
              keys="hn,patientName,queueDate,appointmentDate,triageLevel,printReport,printLMR,status,discharge,cancel"
              loading={props.loading}
              onPageChange={props.handlePageChange}
              onPageSizeChange={props.handlePageSizeChange}
              page={props.currentPage}
              pageSize={props.limit}
              pages={props.totalPage}
              showPageSizeOptions={false}
              showPagination={!props.pagination}
              style={props.tableStyle || { height: "calc(100vh - 16.5rem)"}}
              widths="180,180,180,140,100,350,100,150,120,160">
            </Table>
            <div
              id="CardPatientQueueUX-div-82"
              style={{display: props.pagination ? "flex" : "none", justifyContent: "flex-end", marginTop: "0.75rem"}}>
              {props.pagination}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardPatientQueueUX

export const screenPropsDefault = {}

/* Date Time : Mon Nov 02 2026 10:01:28 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"15px 10px\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-Form-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormGroup-32"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormGroup-33"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-34"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-35"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-36"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"30px\" }"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-37"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-38"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-39"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"30px\" }"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-40"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-41"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-42"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "Member ID"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-label-43"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - นามสกุล"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-label-44"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ตรวจ"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-label-45"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-label-46"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Input",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-Input-52"
        },
        "name": {
          "type": "value",
          "value": "patient__hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.patientQueueFilter?.patient__hn"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Input",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-Input-53"
        },
        "name": {
          "type": "value",
          "value": "first_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.patientQueueFilter?.first_name"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Input",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-Input-54"
        },
        "name": {
          "type": "value",
          "value": "last_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.patientQueueFilter?.last_name"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 55,
      "name": "DateTextBox",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-DateTextBox-55"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFromDate"
        },
        "value": {
          "type": "code",
          "value": "props.patientQueueFilter?.from_date"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 56,
      "name": "DateTextBox",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-DateTextBox-56"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeToDate"
        },
        "value": {
          "type": "code",
          "value": "props.patientQueueFilter?.to_date"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-57"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-58"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-59"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"30px\" }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-FormField-60"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"30px\" }"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะรับบริการ"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-label-62"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Dropdown",
      "parent": 64,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-Dropdown-70"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.encounterStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.patientQueueFilter?.status"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", gap: \"10px\" }"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-75"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-76"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-77"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Checkbox",
      "parent": 75,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.patientQueueFilter?.exclude_finished"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-Checkbox-78"
        },
        "label": {
          "type": "value",
          "value": "แสดงรายการที่ยังไม่รับบริการเสร็จสิ้น"
        },
        "name": {
          "type": "value",
          "value": "exclude_finished"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "Checkbox",
      "parent": 71,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.patientQueueFilter?.exclude_canceled"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-Checkbox-79"
        },
        "label": {
          "type": "value",
          "value": "แสดงรายการที่ไม่ถูกยกเลิก"
        },
        "name": {
          "type": "value",
          "value": "exclude_canceled"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-80"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 81,
      "name": "Table",
      "parent": 80,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.patientQueueData"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "props.defaultPageSize"
        },
        "headers": {
          "type": "code",
          "value": "`MemberID\\n(หมายเลขรับบริการ),ชื่อผู้รับบริการ,วันเวลารับบริการ,วันเวลานัดหมาย,คัดกรอง,เอกสารสำหรับผู้รับบริการ,พิมพ์LMR,สถานะรับบริการ,,`"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-Table-81"
        },
        "keys": {
          "type": "value",
          "value": "hn,patientName,queueDate,appointmentDate,triageLevel,printReport,printLMR,status,discharge,cancel"
        },
        "loading": {
          "type": "code",
          "value": "props.loading"
        },
        "minRows": {
          "type": "code",
          "value": ""
        },
        "onPageChange": {
          "type": "code",
          "value": "props.handlePageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.handlePageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.currentPage"
        },
        "pageSize": {
          "type": "code",
          "value": "props.limit"
        },
        "pages": {
          "type": "code",
          "value": "props.totalPage"
        },
        "showPageSizeOptions": {
          "type": "code",
          "value": "false"
        },
        "showPagination": {
          "type": "code",
          "value": "!props.pagination"
        },
        "style": {
          "type": "code",
          "value": "props.tableStyle || { height: \"calc(100vh - 16.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "180,180,180,140,100,350,100,150,120,160"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardPatientQueueUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{display: props.pagination ? \"flex\" : \"none\", justifyContent: \"flex-end\", marginTop: \"0.75rem\"}"
        }
      },
      "seq": 82,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardPatientQueueUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
